import { combineReducers } from "redux";
import { dynamicInvoicesPagesReducer } from "./pages";
export const dynamicInvoicesReducer = combineReducers({
    dynamicInvoicesPages: dynamicInvoicesPagesReducer
});
